// src/redux/store.js

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "../reducers/userReducer";
// import investmentReducer from "./reducers/investmentReducer"; // Non-persistent reducer
import notificationReducer from "../reducers/notificationReducer";
import legalTeamNotificationReducer from "../reducers/legalteamNotificationReducer";

// Configuration for persisting only userReducer
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"], // Only persist userReducer
};

// Combine your reducers
const rootReducer = combineReducers({
  user: userReducer, // Persistent
  notifications:notificationReducer,
  notification:legalTeamNotificationReducer,
});

// Create a persisted reducer for only the reducers in the whitelist
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability check for persisted state
    }),
});

// Persist the store
const persistor = persistStore(store);

export { store, persistor };
